<template>
  <div class="header-container">
    <div
      class="header-container-fixed"
      :class="{
        shrink
      }"
    >
      <h1 class="header-title">{{ system.title }}</h1>
      <div class="header-logo">
        <router-link :to="{ name: 'home' }">
          <img :src="system.logo" :alt="system.title" :title="system.title" />
        </router-link>
      </div>
      <div class="header-switch" @click="$emit('switch', !shrink)">
        <i
          class="iconfont"
          :class="{
            iconguanbi: shrink,
            icongengduo: !shrink
          }"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState("system", ["system"]),
  props: {
    shrink: {
      type: Boolean,
      default: false
    }
  }
};
</script>
